export const ACTION_TYPES = {
  create: 'create',
  delete: 'delete',
  update: 'update',
}
